// extracted by mini-css-extract-plugin
export var articles_list_wrapper = "ArticlesList-module--articles_list_wrapper--w4kEe";
export var articles_list = "ArticlesList-module--articles_list--hDnSg";
export var title = "ArticlesList-module--title--KUkW7";